// extracted by mini-css-extract-plugin
export var currencyInput = "_nc-1";
export var currencySymbol = "_nc-0";